// Where widget authors can get started. The starter zip is built from docs/widgets/starter
// (see docs/widgets/README.md → "Rebuilding the starter zip") and served from /public.

export const WIDGET_STARTER_URL = `${process.env.PUBLIC_URL || ''}/widget-starter.zip`;
export const WIDGET_STARTER_FILENAME = 'momentum-widget-starter.zip';

// Kept in sync with docs/widgets/{README,INSTALLING,ROUTES}.md by copying (same pattern as the starter
// zip above) — see package.json's "copy-widget-docs" script (runs on every start/build).
// Rendered in-app by WidgetDocsModal
// instead of just linking to a raw file, so this now actually shows up somewhere a widget
// author or an installer would see it (previously WIDGET_DOCS_PATH existed but nothing used it).
export const WIDGET_DOCS_URL = `${process.env.PUBLIC_URL || ''}/docs/widgets/README.md`;
export const WIDGET_INSTALL_DOCS_URL = `${process.env.PUBLIC_URL || ''}/docs/widgets/INSTALLING.md`;
export const WIDGET_ROUTES_DOCS_URL = `${process.env.PUBLIC_URL || ''}/docs/widgets/ROUTES.md`;
